<template>
  <div class="container lms-wrapper-two">

    <researcher-nav />

    <div class="lms-content" @click="closeLevel2()">
      <stf-header class="filled" ref="lmsv4header" />

      <div class="lms-content-body" style="height: calc(100vh - 80px); overflow: auto">
        <div class="mg-20 bg-white rounded-20 pd-20" v-if="taskRdy">
          <h4 class="mg-b-10 pd-b-10 bd-b">Сонгон шалгаруулалтын зарын мэдээлэл</h4>
          <div class="text-center mg-y-20">
            <h3 class="mg-b-0">{{ task.task }}</h3>
          </div>
          <table class="wd-100p">
            <tbody>
              <tr>
                <th class="pd-b-20">НЭР:</th>
                <td class="pd-b-20">{{ task.task }}</td>
              </tr>
              <tr>
                <th class="pd-b-20">Материал авч эхлэх:</th>
                <td class="pd-b-20 pd-l-10"> {{ task.d1 | moment('YYYY.MM.DD- ны HH цаг mm минут') }}</td>
              </tr>
              <tr>
                <th class="pd-b-20">Материал авч дуусах:</th>
                <td class="pd-b-20 pd-l-10"> {{ task.d2 | moment('YYYY.MM.DD- ны HH цаг mm минут') }}</td>
              </tr>
              <!-- <tr>
                <th class="pd-b-20">Зарласан төслийн төрөл:</th>
                <td class="pd-b-20">{{ task.locTypeName }}</td>
              </tr> -->
              <tr>
                <th class="pd-b-20">Төлөв:</th>
                <td class="pd-b-20">
                  <span class="bg-primary rounded pd-x-10 pd-y-5 text-white">{{ getStts() }}</span>
                </td>
              </tr>
              <tr>
                <!-- <th class="pd-b-20" style="min-width: 200px">Төслийн дэлгэрэнгүй мэдээ:</th> -->
                <td class="pd-b-20" colspan="2">
                  <div class="pd-l-20" v-html="task.taskDesc"></div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="d-flex wd-100p" v-if="getSttsBool()">
            <router-link :to="{name: 'dzAdApply' ,params:{ id: task.id, tsk: 0 } }" role="button" class="btn text-white btn-primary mg-l-auto wd-200">Хүсэлт илгээх</router-link>
          </div>
        </div>
      </div>


    </div>

    <div>



    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";

export default {
  components: {
    vueCustomScrollbar,

    researcherNav: () => ({
      component: import("@/views/home/apps/dz/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    stfHeader: () => ({
      component: import("@/views/home/apps/stf/researcher/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
  },
  data() {
    return {
      task: {},
      taskRdy: false,
      nowDate: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    getStts(){

      if (moment(this.task.d2).isBefore(moment())  ) {
        return "хаагдсан";
      } else {
        return "нээлттэй";
      }
    },
    getSttsBool(){
      if (moment(this.task.d2).isBefore(moment())  ) {
        return false;
      } else {
        return true;
      }
    },
    logout() {
      this.$refs.lmsv4header.logout();
    },
    searchHandler() {
      //console.log('srch handled');
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
      //console.log(shown, this.navbarMode);
    },
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init() {
      request({
        // api: { method: "POST", url: "v2/learn/studentHomeData" },
        api: { method: "GET", url: "task/TaskInheritedDetail" },
        params: { id: this.$route.params.id },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.taskRdy= true;
          //console.log('res', res);
          this.task = res.data.task;
        }
      });

      // let _learnExamRegistration = this.getConfigValueByKey(
      //   "learnExamRegistration"
      // );
      // if (this.$store.state.app.activeGroup.id == 6126) {
      //   if (this.$store.state.user.userInfo.locType4Code != "member") {
      //     this.learnExamRegistration = parseInt(_learnExamRegistration, 10);
      //   }
      // } else {
      //   this.learnExamRegistration = parseInt(_learnExamRegistration, 10);
      // }
    },
  },
};
</script>
